import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { CaseStudiesDetail } from './components/caseStudiesDetail';
import { ServicesDetail } from './components/serviceDetail';
import { Navigation } from './components/navigation';
import { Contact } from './components/contact';
import JsonData from "./data/data.json";

const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path='/' element={<App />}>
          </Route>
          <Route path='/case-studies/:slug' element={<CaseStudiesDetail />} />
          <Route path='/services/:slug' element={<ServicesDetail />} />
        </Routes>
        <Outlet />
        <Contact data={JsonData.Contact} />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

const rootElement = document.getElementById('root');

// react-snap pre-renders each route to static HTML at build time. When that
// markup is already present we hydrate it (reuse the DOM) instead of throwing
// it away with a fresh render — this is what lets crawlers see real content.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(tree, rootElement);
} else {
  ReactDOM.render(tree, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
